module.exports = __webpack_public_path__ + "img/Resume.c903d4ce.png";